export type CalendarSettingsState = {
  startHour: number | null;
  endHour: number | null;
  isFetched: boolean;
};

export const calendarSettingsInitialState: CalendarSettingsState = {
  startHour: null,
  endHour: null,
  isFetched: false,
};

export type CalendarDisplayHoursResponse = {
  calendar_display_start_hour: number | null;
  calendar_display_end_hour: number | null;
};

export type CalendarDisplayHoursPayload = {
  calendar_display_start_hour: number;
  calendar_display_end_hour: number;
};
